require('../../modules/es6.regexp.split');
module.exports = require('../../modules/_wks-ext').f('split');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/symbol/split.js
// module id = hSgm
// module chunks = 3